<div class="info-row">
  <span class="file-name">{{file.name}}</span>
  <span *ngIf="hasFailed"   class="error-message">{{'Errors.fileUpload' | translate}}</span>
  <span *ngIf="isDuplicate" class="error-message">{{'Errors.duplicateFile' | translate}}</span>
</div>

<div class="indicator-row">
  <div class="progress">
    <div class="progress-bar" [style.width]="progress + '%'"></div>
  </div>
  <div class="indicator-extra">
    <span class="indicator-text">{{'NewTranslation.nPercent' | translate:{value: progress} }}</span>
    <cp-button *ngIf="isUploading || isReady" icon="remove-outline" (click)="onRemove(file, $event)"></cp-button>
    <cp-button *ngIf="isComplete"             icon="delete-outline" (click)="onRemove(file, $event)"></cp-button>
    <cp-button *ngIf="hasError"               icon="error-outline"  (click)="onRemove(file, $event)"></cp-button>
  </div>
</div>
